import { createElement, useState } from "react";
import { InternalAssessmentApiModel, InternalAssessmentApiRow } from "../../../../internalAssessment/InternalAssessments.types";
import { deleteHttp } from "../../../../common/api/apiShared";
import { IProcessingActivityInternalAssessmentTabProps } from "./ProcessingActivityInternalAssessment";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { Trans } from "react-i18next";
import { useDotLegalQuery, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export default function useProcessingActivityInternalAssessmentTabHooks(props: IProcessingActivityInternalAssessmentTabProps) {
    const snackbar = useDotLegalSnackbar();
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectedInternalAssessment, setSelectedInternalAssessment] = useState<InternalAssessmentApiRow | undefined>(undefined);

    const url = `/processingActivityAssociatedInternalAssessment/${props.processingActivityId}`;
    const { isLoading, data, refetch } = useDotLegalQuery<InternalAssessmentApiModel>(url);

    const removeAssociatedInternalAssessmentMutation = useDotLegalMutation(removeAssociatedInternalAssessmentAPI);

    const removeAssociatedInternalAssessment = async () => {
        removeAssociatedInternalAssessmentMutation.mutateAsync(undefined, {
            onSuccess: () => {
                refetch();
                props.onAuditsChanged();
                setShowDeleteDialog(false);
                snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: selectedInternalAssessment?.name } }));
            },
        });
    };

    async function removeAssociatedInternalAssessmentAPI() {
        return await deleteHttp<string>("/processingActivityAssociatedInternalAssessment/" + props.processingActivityId + "/" + selectedInternalAssessment?.id);
    }

    return {
        showAddDialog,
        setShowAddDialog,
        isLoading,
        data,
        refetch,
        showDeleteDialog,
        setShowDeleteDialog,
        setSelectedInternalAssessment,
        removeAssociatedInternalAssessment,
        isRemoving: removeAssociatedInternalAssessmentMutation.isLoading,
        selectedInternalAssessment,
    };
}
